export default {
    title: '会社情報管理',
    pageTitle: '企業情報',
    basicInfo: '基本情報',
    personInCharge: '責任者情報',
    affiliatedEntity: '所属先',
    commonDocuments: '常用資料',
    registrationInfo: '登録支援機構',
    companyName: '名称',
    legalEntity: '法人',
    legalEntityNumber: '法人番号（13桁）',
    legalPersonId: '法人番号（13桁）',
    registrationDate: '登録日',
    establishmentDate: '登録資本（円）',
    employeeCount: '会社規模',
    foreignEmployeeCount: '外国語従業員規模',
    businessScope: '売上規模（円/年）',
    website: '会社ウェブサイト',
    officeAddress: '本社住所',
    companyIntroduction: '会社紹介',
    registrationSupportService: '登録支援業務',
    trustMethod: '委託方法',
    remarks: '備考',
    contactName: '氏名',
    contactPosition: '役職',
    contactPhone: '電話番号／携帯番号',
    contactEmail: 'メールアドレス',
    mainIndustry: '主要業種',

    inputPlaceholder: '入力してください',
    selectPlaceholder: '選択してください',
    datePlaceholder: 'YYYY-MM-DD',
    validation: {
        companyNameRequired: '名称を入力してください',
        mainIndustryRequired: '主要業種を選択してください',
        legalEntityRequired: '法人を入力してください',
        employeeCountRequired: '会社規模を選択してください',
        foreignEmployeeCountRequired: '外国語従業員規模を選択してください',
        contactNameRequired: '氏名を入力してください',
        contactPhoneRequired: '電話番号／携帯番号を入力してください',
        legalPersonIdRequired: '法人番号を入力してください',
        corporateNumberLength: '法人番号は13桁の数字である必要があります',
        insuranceNumberRequired: '雇用保険適用企業番号を入力してください',
        insuranceOfficeNumberRequired: '雇用保険適用事業所番号を入力してください',
        employmentOfficeNumberLength: '雇用保険適用事業所番号は11桁の数字である必要があります',
        companyCategoryRequired: '会社区分を選択してください',
        companyTypeRequired: '会社の種類を選択してください',
    },
};
